import { Component, OnInit,Input, EventEmitter, Output } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
declare var $;
@Component({
  selector: 'app-rel-query',
  templateUrl: './rel-query.component.html',
  styleUrls: ['./rel-query.component.css']
})
export class RelQueryComponent implements OnInit {
  @Input() modelVerId:string;              // 模型版本id
  @Input() selectConcept:any;              // 选中的概念
  @Input() isRecordVersion: any = null;    // 是否为历史模型版本
  @Input() userRole: string = null;        // 当前用户角色
  @Input() refreshState: any = null;    // 刷新
  // 点击编辑、查看、删除等功能按钮后向父组件发射数据
  @Output('toolbarBtnClick') toolbarBtnClick = new EventEmitter<any>(); 
  formModel:any = {}; // 表单信息
  // 搜索关系名称
  relationName = '';
  // 搜索概念id
  conceptId = '';
  // 概念数据
  concepts: any = [];
  relationDatas:any = [];
  relationDatasCopy:any = [];
  constructor(
    private kmsService: KmsService,
    private message: SwMassageBoxService,
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.getDatas();
  }

  // 切换搜索概念名称
  searchConceptChange(event) {
    this.conceptId = event.id;
  }

  // 清除搜索概念名称
  clearSearchConcept(event) {
      this.conceptId = '';
  }

  // 查询数据
  getDatas(){
    let params = {
      "conceptId": this.selectConcept.conceptId,
      "modelVerId": this.modelVerId,
    }
    this.kmsService.getRelationDatas(params).subscribe(
      res => {
        if (res.code == 200) {
          this.relationDatas = res.data;
          this.concepts = [];
          for(let i=0;i<this.relationDatas.length;i++){
            let item = this.relationDatas[i];
            item['isCollapse'] = false; 
            if(this.concepts.filter(el => el.id == item.sourceConceptId).length == 0){
              this.concepts.push({
                id:item.sourceConceptId,
                text:item.sourceConceptName
              });
            }
            if(this.concepts.filter(el => el.id == item.targetConceptId).length == 0){
              this.concepts.push({
                id:item.targetConceptId,
                text:item.targetConceptName
              });
            } 
          }
          this.relationDatasCopy = JSON.parse(JSON.stringify(this.relationDatas));
        }
      }
    )
  }

  // 根据关联概念、关联关系过滤数据
  search(){
    let relationName = $.trim(this.relationName);
    if(!this.conceptId && !relationName){
      this.relationDatas = JSON.parse(JSON.stringify(this.relationDatasCopy));
    }else if(this.conceptId && !relationName){
      this.relationDatas = this.relationDatasCopy.filter(el => el.sourceConceptId == this.conceptId || el.targetConceptId == this.conceptId);
    }else if(!this.conceptId && relationName){
      let arr = JSON.parse(JSON.stringify(this.relationDatasCopy));
      this.relationDatas = this.searchByName(arr,relationName);
    }else{
      let arr = this.relationDatasCopy.filter(el => el.sourceConceptId == this.conceptId || el.targetConceptId == this.conceptId);
      this.relationDatas = this.searchByName(arr,relationName);
    }
  }

  // 根据关系名称过滤
  searchByName(arr,relationName){
    let relationArr = [];
    arr.forEach(el => {
      let arr1 = [];
      el.relationships.forEach(el1 => {
        if((el1.relationName.indexOf(relationName) > -1) || (el1.reverseRelationName && el1.reverseRelationName.indexOf(relationName) > -1)){
          arr1.push(el1);
        }
      })
      if(arr1.length>0){
        el.relationships = JSON.parse(JSON.stringify(arr1));
        relationArr.push(el);
      }
    })
    return relationArr;
  }

  // 重置搜索条件
  reset(){
    this.conceptId = '';
    this.relationName = '';
    this.search();
  }

  // 操作按钮点击事件
  toolbarClick(child,state){
    // 查看操作不受限制
    if(state === 'relView'){
      this.toolbarBtnClick.emit({
        state: state,
        selectRel: child
      });
    }else{
      // 知识库管理员才可以对非历史模型版本（即最新版本）的非继承关系可进行编辑、删除操作
      if(this.userRole == '知识库管理员' && !this.isRecordVersion){
        if(!child.isInherit){
          this.toolbarBtnClick.emit({
            state: state,
            selectRel: child
          });
        }
      }
    }
  }
}
